// This list comes from this thread from Slack: https://coursera.slack.com/archives/C07FMU3CC0G/p1736366076994799

export const RANKED_ROLES_LIST = [
  'data-scientist',
  'data-analyst',
  'machine-learning-engineer',
  'it-project-manager',
  'technology-consultant',
  'business-management-analyst',
  'business-intelligence-analyst',
  'data-warehouse-developer',
  'product-manager',
  'marketing-analytics-specialist',
  'business-analyst-general',
  'statistician',
  'project-manager',
  'video-game-developer',
  'data-architect',
  'cyber-security-engineer',
  'logistics-supply-chain-analyst',
  'mainframe-developer',
  'automation-engineer',
  'user-interface-user-experience-ui-ux-manager',
  'cyber-information-security-engineer-analyst',
  'back-end-developer-engineer',
  'data-engineer',
  'technical-support-engineer-analyst',
  'social-media-strategist-specialist',
  'real-estate-agent',
  'tax-analyst-specialist',
  'human-resources-specialist',
  'bookkeeper-accounting-clerk',
  'sales-representative',
  'full-stack-developer',
  'ios-developer-engineer',
  'scrum-master',
  'cloud-architect',
  'sales-development-representative',
  'digital-marketing-specialist',
  'cyber-security-specialist-technician',
  'solutions-application-architect',
  'sales-operations-specialist',
  'front-end-developer',
  'devops-engineer',
  'customer-service-representative',
  'application-developer-engineer',
  'android-developer-engineer',
  'network-systems-administrator',
  'career-counselor',
  'network-engineer-architect',
  'computer-support-specialist',
  'analytics-manager',
  'actuary',
  'risk-consultant',
  'market-research-analyst',
  'computer-scientist',
  'business-intelligence-architect-developer',
  'data-warehousing-specialist',
  'strategic-planner-analyst',
  'business-management-consultant',
  'risk-analyst',
  'diversity-equity-and-inclusion-specialist',
  'chief-information-officer',
  'risk-manager-analyst',
  'chief-data-officer',
  'aerospace-engineer',
  'researcher-research-associate',
  'fraud-examiner-analyst',
  'business-program-analyst',
  'data-data-mining-analyst',
  'corporate-development-analyst',
  'advertising-promotions-manager',
  'program-manager',
  'marketing-analyst',
  'pricing-analyst',
  'supply-chain-analyst',
  'talent-acquisition-recruiting-manager',
  'sustainability-specialist',
  'human-resources-analyst',
  'data-manager',
  'market-research-analyst-general',
  'risk-manager',
  'financial-quantitative-analyst',
  'biologist',
  'business-development-manager',
  'business-analysis-manager',
  'project-management-analyst',
  'human-resources-consultant',
  'product-manager-general',
  'e-commerce-analyst',
  'writer',
  'director-of-project-management',
  'compensation-benefits-analyst',
  'budget-analyst',
  'systems-engineer',
  'energy-engineer',
  'employee-relations-specialist',
  'logistics-analyst',
  'chemical-process-engineer',
  'product-development-manager',
  'systems-integration-engineer-specialist',
  'inventory-control-manager',
  'compensation-benefits-manager',
];

export default {
  RANKED_ROLES_LIST,
};
